import { UserSettings } from '../models/usersettings.model';
export class User {
  //combination of Azure AD User and AD Org info
  //this info is populated from checkUser function in the login service
  upn: string;
  tenantName: string;
  orgName: string;
  givenName: string;
  surname: string;
  settings: UserSettings;
  tenantId: string;
  memberOf: any[];
  memberOfAU: any[];

  constructor() {}
}
